module.exports = __webpack_public_path__ + "img/logo.77d16f5e.png";